(function() {
  function initMegaMenu() {
    var megaMenus = document.querySelectorAll('.mrm-mega');
    megaMenus.forEach(function(menu) {
      var catItems = menu.querySelectorAll('.mrm-mega__cat-item');
      var subPanels = menu.querySelectorAll('.mrm-mega__sub');
      var sectionLabels = menu.querySelectorAll('.mrm-mega__section-label');

      function clearAll() {
        catItems.forEach(function(ci) { ci.classList.remove('is-active'); });
        subPanels.forEach(function(sp) { sp.classList.remove('is-active'); });
      }

      // Survol des labels de section -> vide la colonne droite
      sectionLabels.forEach(function(label) {
        label.addEventListener('mouseenter', clearAll);
      });

      // Survol des catégories -> affiche les sous-items correspondants
      catItems.forEach(function(item) {
        item.addEventListener('mouseenter', function() {
          var index = this.getAttribute('data-index');
          clearAll();
          this.classList.add('is-active');
          var target = menu.querySelector('.mrm-mega__sub[data-index="' + index + '"]');
          if (target) target.classList.add('is-active');
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaMenu);
  } else {
    initMegaMenu();
  }
})();
